import { Form } from 'antd';
import { Link as RouterLink } from 'react-router-dom';
import styled from 'styled-components';

export const ContainerAuth = styled.main`
  width: 100vw;
  height: 100vh;
  background-color: #374151;
  padding-top: 40px;
  font-family: 'Roboto', sans-serif;

  > h1 {
    font-size: 35px;
    color: var(--white);
    margin-bottom: 20px;
    text-align: center;
  }

  .ant-image {
    margin: auto;
    display: block;
  }

  img {
    margin-bottom: 20px;
  }
`;

export const ContentAuth = styled.div`
  display: flex;
  flex-direction: column;
  background-color: var(--white);
  padding: 15px;
  margin: 0 10px;
  border-radius: 10px;
  margin-bottom: 40px;
  min-height: 350px;
`;

export const LinkAuth = styled(RouterLink)`
  display: block;
  color: gray;

  &:hover {
    color: gray;
  }
`;

export const FormAuth = styled(Form)`
  width: 100%;

  input {
    border-radius: 4px;
  }
`;
